import { useNavigate } from "react-router-dom";
import "./new-branch.scss";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { MessageResponseDto } from "@api/api";
import { useQyCreateBranch } from "@core/query/branch.query";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { BranchFormRule, BranchFormSchema } from "@core/form/form.rule";
import { branchFormDefault } from "@core/form/form.default";
import { zodResolver } from "@hookform/resolvers/zod";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import FormBranch from "../form-branch/form-branch";
import { FaChevronLeft } from "react-icons/fa6";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";

export function NewBranch() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapNewBranch } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New branch is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addBranch, isLoading: isCreating } =
    useQyCreateBranch(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<BranchFormSchema>({
    defaultValues: branchFormDefault,
    resolver: zodResolver(BranchFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: BranchFormSchema) => {
    const formData = mapNewBranch(form);
    addBranch(formData);
  };
  const handleValidateError = (err: FieldErrors<BranchFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="NewBranch" className="new-branch">
      <HeaderContent
        title="New Branch"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormBranch />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewBranch;
